// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__dehHt","title":"Info_title__1uXB9","selects":"Info_selects__3zmZo","requiredAsterisk":"Info_requiredAsterisk__366kG"};